import React, { useEffect, useState } from 'react';
import {
  availabilityGET,
  availabilityPOST,
  availabilityDELETE
} from './Availability';

const AvailabilitySelector = () => {
  const [selectedDays, setSelectedDays] = useState([]);

  const days = ['M', 'Tu', 'W', 'Th', 'F', 'Sa', 'Su'];

  const dayMap = {
    M: 'M',
    Tu: 'T',
    W: 'W',
    Th: 'TH',
    F: 'F',
    Sa: 'S',
    Su: 'SU',
  };

  const reverseDayMap = {
    M: 'M',
    T: 'Tu',
    W: 'W',
    TH: 'Th',
    F: 'F',
    S: 'Sa',
    SU: 'Su',
  };

  // Fetch availability from API
  const fetchAvailability = async () => {
    try {
      const response = await availabilityGET();

      const availableDays = response
        .map((entry) => reverseDayMap[entry.day_of_week.toUpperCase()])
        .filter(Boolean);

      setSelectedDays(availableDays);
    } catch (err) {
      console.error('❌ Failed to fetch availability:', err.message);
    }
  };


  useEffect(() => {
    fetchAvailability(); // Load on mount
  }, []);

  const toggleDay = async (day) => {
    const isSelected = selectedDays.includes(day);
    const apiDay = dayMap[day];

    // Optimistically update UI
    const updatedDays = isSelected
      ? selectedDays.filter((d) => d !== day)
      : [...selectedDays, day];

    setSelectedDays(updatedDays); // update UI first

    try {
      if (isSelected) {
        await availabilityDELETE({ day_of_week: apiDay });
      } else {
        await availabilityPOST({ day_of_week: apiDay });
      }
    } catch (err) {
      console.error('⚠️ Failed to update availability:', err.message);

      // Roll back UI if API fails
      setSelectedDays(selectedDays); // restore original state
    }
  };


  return (
    <div className="col-md-12 mb-3">
      <label className="form-label d-block mb-2">Availability</label>
      <div className="d-flex justify-content-between gap-2 flex-wrap">
        {days.map((day, i) => (
          <span
            key={i}
            onClick={() => toggleDay(day)}
            className={`border rounded px-3 py-1 ${selectedDays.includes(day)
                ? 'bg-primary text-white'
                : ['Sa', 'Su'].includes(day)
                  ? 'bg-secondary text-white'
                  : ''
              }`}
            style={{
              cursor: 'pointer',
              minWidth: '40px',
              textAlign: 'center',
              flex: '1 1 12%', // Responsive but no overflow
            }}
          >
            {day}
          </span>
        ))}
      </div>
    </div>

  );
};

export default AvailabilitySelector;
